(() => {
  function initializeProducts(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.commerceReady) return;
      section.dataset.commerceReady = 'true';
      const picker = section.querySelector('[data-variant-select]');
      const variantInput = section.querySelector('[data-variant-input]');
      const addButton = section.querySelector('[data-product-add]');
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const quantity = section.querySelector('[data-product-quantity]');
      const availability = section.querySelector('[data-product-availability]');
      const dynamicCheckout = section.querySelector('[data-dynamic-checkout]');
      const productImage = section.querySelector('[data-product-image]');
      const planPicker = section.querySelector('[data-selling-plan]');
      const requiresPlan = section.dataset.requiresPlan === 'true';
      const labels = section.dataset;
      if (!variantInput || !addButton) return;
      const sizeButtons = [...section.querySelectorAll('[data-size-variant]')];
      let hasChosenSize = !sizeButtons.length || new URLSearchParams(location.search).has('variant');
      const sizeGuide = section.querySelector('[data-size-guide]');
      section.querySelector('[data-open-size-guide]')?.addEventListener('click', () => {
        if (!sizeGuide) return;
        sizeGuide.open = true;
        sizeGuide.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        sizeGuide.querySelector('summary')?.focus();
      });

      function selectedVariant() {
        return picker ? picker.selectedOptions[0] : variantInput;
      }
      function plansFor(selected) {
        try { return JSON.parse(selected.dataset.plans || '[]'); }
        catch { return []; }
      }
      function updatePurchase() {
        const selected = selectedVariant();
        if (!selected) return;
        const plan = planPicker && plansFor(selected).find((entry) => entry.id === planPicker.value);
        const available = selected.dataset.available === 'true' && (!requiresPlan || Boolean(plan));
        price.textContent = plan ? plan.price : selected.dataset.price;
        const comparison = plan ? plan.compare : selected.dataset.compare;
        compare.textContent = comparison || '';
        compare.hidden = !comparison;
        addButton.disabled = !available;
        const unavailableLabel = selected.dataset.available === 'true' ? labels.labelUnavailable : labels.labelSoldOut;
        addButton.textContent = available ? (hasChosenSize ? labels.labelAddToCart : labels.labelChooseSize) : unavailableLabel;
        section.dataset.sizeChosen = String(hasChosenSize);
        const mobile = section.querySelector('[data-mobile-add]');
        if (mobile) { mobile.textContent = addButton.textContent; mobile.disabled = addButton.disabled; }
        const mobilePrice = section.querySelector('[data-mobile-price]');
        if (mobilePrice) mobilePrice.textContent = price.textContent;
        availability.textContent = available ? '' : (selected.dataset.available === 'true' ? labels.messageUnavailable : labels.messageSoldOut);
        if (dynamicCheckout) dynamicCheckout.hidden = !available || !hasChosenSize;
        sizeButtons.forEach((button) => button.setAttribute('aria-pressed', String(hasChosenSize && button.dataset.sizeVariant === selected.value)));
      }
      function updateVariant() {
        hasChosenSize = true;
        const selected = selectedVariant();
        if (!selected) return;
        variantInput.value = selected.value;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (planPicker) {
          const previousPlan = planPicker.value;
          const plans = plansFor(selected);
          planPicker.replaceChildren();
          if (!requiresPlan) planPicker.add(new Option(labels.labelOneTime, ''));
          plans.forEach((plan) => planPicker.add(new Option(`${plan.name} — ${plan.price}`, plan.id)));
          if (plans.some((plan) => plan.id === previousPlan)) planPicker.value = previousPlan;
          planPicker.closest('.commerce-field').hidden = plans.length === 0;
        }
        updatePurchase();
        const minimum = Number(selected.dataset.min) || 1;
        const step = Number(selected.dataset.step) || 1;
        quantity.min = String(minimum);
        quantity.step = String(step);
        if (selected.dataset.max) quantity.max = selected.dataset.max;
        else quantity.removeAttribute('max');
        if (!quantity.checkValidity()) quantity.value = String(minimum);
        if (productImage && selected.dataset.image) {
          const shotColor = selected.dataset.color;
          const shotThumbs = section.querySelector('[data-color-thumbs]');
          const pressed = shotThumbs?.querySelector('[data-shot-rank][aria-pressed="true"]');
          const preferRank = pressed?.dataset.shotRank || section.dataset.viewRank || '';
          let heroSrc = selected.dataset.image;
          let heroAlt = selected.dataset.imageAlt || '';
          let heroLarge = selected.dataset.imageLarge || selected.dataset.image;
          if (shotThumbs && shotColor) {
            shotThumbs.querySelectorAll('[data-shot-color]').forEach((thumb) => {
              thumb.hidden = thumb.dataset.shotColor !== shotColor;
              thumb.setAttribute('aria-pressed', 'false');
            });
            const visible = [...shotThumbs.querySelectorAll('[data-shot-rank]')].filter((thumb) => !thumb.hidden);
            const pick = (rank) => visible.find((thumb) => thumb.dataset.shotRank === rank);
            let next = preferRank ? pick(preferRank) : null;
            if (!next && preferRank === '1') next = pick('4');
            if (!next && preferRank === '2') next = pick('3');
            if (!next && preferRank === '4') next = pick('1');
            if (!next && preferRank === '3') next = pick('2');
            if (!next) next = pick('4') || pick('3') || visible[0];
            if (next) {
              heroSrc = next.dataset.gallerySwitch;
              heroAlt = next.dataset.imageAlt || heroAlt;
              heroLarge = next.dataset.largeSrc || heroSrc;
              next.setAttribute('aria-pressed', 'true');
              section.dataset.viewRank = next.dataset.shotRank;
            }
          }
          productImage.removeAttribute('srcset');
          productImage.src = heroSrc;
          productImage.alt = heroAlt;
          const heroTrigger = productImage.closest('[data-gallery-open]');
          if (heroTrigger) {
            heroTrigger.dataset.largeSrc = heroLarge;
            heroTrigger.dataset.imageAlt = productImage.alt;
          }
          if (!shotThumbs || !shotColor) {
            section.querySelectorAll('[data-gallery-switch]').forEach((thumbnail) => {
              thumbnail.setAttribute('aria-pressed', String(thumbnail.dataset.gallerySwitch === heroSrc));
            });
          }
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        if (planPicker && planPicker.value) url.searchParams.set('selling_plan', planPicker.value);
        else url.searchParams.delete('selling_plan');
        window.history.replaceState({}, '', url);
      }
      if (picker) {
        picker.form.addEventListener('submit', (event) => {
          event.preventDefault();
          updateVariant();
        });
        picker.addEventListener('change', updateVariant);
        sizeButtons.forEach((button) => button.addEventListener('click', () => {
          picker.value = button.dataset.sizeVariant;
          updateVariant();
        }));
      }
      if (planPicker) planPicker.addEventListener('change', updatePurchase);
      section.querySelector('[data-color-thumbs]')?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-shot-rank]');
        if (button) section.dataset.viewRank = button.dataset.shotRank;
      });
      updatePurchase();
    });
  }
  function initializeGalleries(scope = document) {
    scope.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.zoomReady) return;
      gallery.dataset.zoomReady = 'true';
      const items = [...gallery.querySelectorAll('[data-gallery-open]')];
      const dialog = gallery.querySelector('[data-product-zoom]');
      if (!dialog || !items.length) return;
      const viewport = dialog.querySelector('[data-zoom-viewport]');
      const image = dialog.querySelector('[data-zoom-image]');
      const current = dialog.querySelector('[data-zoom-current]');
      const total = dialog.querySelector('[data-zoom-total]');
      const level = dialog.querySelector('[data-zoom-level]');
      const zoomIn = dialog.querySelector('[data-zoom-in]');
      const zoomOut = dialog.querySelector('[data-zoom-out]');
      const previous = dialog.querySelector('[data-zoom-previous]');
      const next = dialog.querySelector('[data-zoom-next]');
      const close = dialog.querySelector('[data-zoom-close]');
      const reset = dialog.querySelector('[data-zoom-reset]');
      const pointers = new Map();
      let index = 0;
      let scale = 1;
      let offsetX = 0;
      let offsetY = 0;
      let gesture = null;
      let opener = null;
      total.textContent = String(items.length);
      previous.hidden = items.length < 2;
      next.hidden = items.length < 2;

      function applyTransform() {
        const maxX = Math.max(0, image.clientWidth * (scale - 1) / 2);
        const maxY = Math.max(0, image.clientHeight * (scale - 1) / 2);
        offsetX = Math.max(-maxX, Math.min(maxX, offsetX));
        offsetY = Math.max(-maxY, Math.min(maxY, offsetY));
        image.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0) scale(${scale})`;
        level.textContent = `${Math.round(scale * 100)}%`;
        zoomOut.disabled = scale <= 1;
        zoomIn.disabled = scale >= 4;
        viewport.dataset.zoomed = String(scale > 1);
      }
      function setScale(value) {
        scale = Math.max(1, Math.min(4, value));
        if (scale === 1) {
          offsetX = 0;
          offsetY = 0;
        }
        applyTransform();
      }
      function show(nextIndex) {
        index = (nextIndex + items.length) % items.length;
        image.src = items[index].dataset.largeSrc;
        image.alt = items[index].dataset.imageAlt || '';
        current.textContent = String(index + 1);
        setScale(1);
      }
      items.forEach((item, itemIndex) => item.addEventListener('click', () => {
        opener = item;
        show(itemIndex);
        dialog.showModal();
        close.focus();
      }));
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        pointers.clear();
        opener?.focus();
      });
      previous.addEventListener('click', () => show(index - 1));
      next.addEventListener('click', () => show(index + 1));
      zoomIn.addEventListener('click', () => setScale(scale + 0.5));
      zoomOut.addEventListener('click', () => setScale(scale - 0.5));
      reset.addEventListener('click', () => setScale(1));
      viewport.addEventListener('dblclick', () => setScale(scale > 1 ? 1 : 2));
      viewport.addEventListener('wheel', (event) => {
        event.preventDefault();
        setScale(scale + (event.deltaY < 0 ? 0.25 : -0.25));
      }, { passive: false });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' && items.length > 1) {
          event.preventDefault();
          show(index - 1);
        } else if (event.key === 'ArrowRight' && items.length > 1) {
          event.preventDefault();
          show(index + 1);
        } else if (event.key === '+' || event.key === '=') {
          event.preventDefault();
          setScale(scale + 0.5);
        } else if (event.key === '-') {
          event.preventDefault();
          setScale(scale - 0.5);
        } else if (event.key === '0') {
          event.preventDefault();
          setScale(1);
        }
      });
      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        viewport.setPointerCapture(event.pointerId);
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (pointers.size === 1) {
          gesture = { startX: event.clientX, startY: event.clientY, offsetX, offsetY };
          viewport.dataset.dragging = String(scale > 1);
        } else if (pointers.size === 2) {
          const [a, b] = [...pointers.values()];
          gesture = { distance: Math.hypot(a.x - b.x, a.y - b.y), scale };
        }
      });
      viewport.addEventListener('pointermove', (event) => {
        if (!pointers.has(event.pointerId)) return;
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (pointers.size === 2 && gesture?.distance) {
          const [a, b] = [...pointers.values()];
          setScale(gesture.scale * Math.hypot(a.x - b.x, a.y - b.y) / gesture.distance);
        } else if (pointers.size === 1 && scale > 1 && gesture?.startX !== undefined) {
          offsetX = gesture.offsetX + event.clientX - gesture.startX;
          offsetY = gesture.offsetY + event.clientY - gesture.startY;
          applyTransform();
        }
      });
      function finishPointer(event) {
        if (!pointers.has(event.pointerId)) return;
        if (pointers.size === 1 && scale === 1 && gesture?.startX !== undefined && items.length > 1) {
          const distanceX = event.clientX - gesture.startX;
          const distanceY = event.clientY - gesture.startY;
          if (Math.abs(distanceX) > 60 && Math.abs(distanceX) > Math.abs(distanceY)) show(index + (distanceX < 0 ? 1 : -1));
        }
        pointers.delete(event.pointerId);
        viewport.dataset.dragging = 'false';
        gesture = null;
      }
      viewport.addEventListener('pointerup', finishPointer);
      viewport.addEventListener('pointercancel', finishPointer);
    });
  }
  initializeProducts();
  initializeGalleries();
  document.addEventListener('shopify:section:load', (event) => {
    initializeProducts(event.target);
    initializeGalleries(event.target);
  });
})();

